<template>
  <div class="div-componentePCUltimosVolcados">
    <!-- No existen registros de volcado -->
    <PCInformacionSinRegistros v-if="(volcados === null || volcados.length === 0) && !mostrarPrecarga && filtro == null" />
    <!-- No existen registros en la busqueda -->
    <UCInformationWithoutSearchRecord v-if="(volcados === null || volcados.length === 0) && !mostrarPrecarga && filtro != null" />

    <!-- Preloader de carga -->
    <UCPreload :show="mostrarPrecarga" />

    <!-- Existen registros de volcados -->
    <!-- VOLCADOS: <pre> {{ volcados }} </pre> -->
    <div
      v-if="volcados != null"
      class="div-registrosDeMovimientos"
    >
      <div
        v-for="volcado in volcados"
        :key="volcado.Id"
        class="div-registroMovimiento"
        @click="VerDetalleVolcado(volcado.Id)"
      >
        <f7-row class="no-padding">
          <f7-col
            class="div-horaRegistroMovimientoYPartida"
            width="80"
          >
            <div class="div-horaRegistroMovimiento">
              {{ FormatearFecha(volcado.FechaInicio) }}
            </div>
            <div class="div-numeroPartida">
              <!-- <span class="span-numeroPartida"> {{ `${volcado.SeriePartida}/${volcado.Numero}` }} </span> -->
              <span class="span-numeroPartida"> {{ volcado.NumeroSerie }} </span>
              <br>
              <span
                v-if="volcado.DatosOrigen != null && volcado.DatosOrigen.length > 0"
                class="span-texto-gris-12-400"
              >
                {{ `${$t('common.originBatch').toUpperCase()}: ${FormatearCadena(ObtenerCadenaNumerosPartidas(volcado.DatosOrigen), 20)}` }}
              </span>
            </div>
          </f7-col>
          <f7-col
            width="20"
            class="col-ttlVolcadoORecuperado"
          >
            <span v-if="volcado.CantidadEnvases > 0">
              {{ $t('production.common.dumped') }}
            </span>
            <span v-if="volcado.CantidadEnvases < 0">
              {{ $t('production.common.retrieved') }}
            </span>
          </f7-col>
        </f7-row>
        <f7-row
          v-if="volcado.FamiliaArticulo != null"
          class="row-nombreProductoYCantidadEnvases no-padding"
        >
          <f7-col
            width="80"
            class="col-productoRegistroMovimiento"
          >
            {{ FormatearCadena(volcado.FamiliaArticulo.Nombre, 23) }}
          </f7-col>
          <f7-col
            width="20"
            class="col-cantidadEnvasesVolcado"
          >
            <span
              v-if="volcado.CantidadEnvases > 0"
              class="span-ttl-unidades-volcadas"
            >{{ volcado.CantidadEnvases }} </span>
            <span
              v-if="volcado.CantidadEnvases < 0"
              class="span-ttl-unidades-recuperadas"
            >{{ volcado.CantidadEnvases }} </span>
          </f7-col>
        </f7-row>
        <f7-row class="no-padding">
          <f7-col
            width="80"
            class="col-productoRegistroMovimiento"
            style="color: var(--his-silver) !important;"
          >
            {{ volcado.LineasPedidoVentaRelacionadas }}
          </f7-col>
        </f7-row>
        <f7-row>
          <PCOperacionesPersonalizadas
            v-if="personalizacionVolcadoPartidasActiva"
            :tipo-entidad="1"
            :entidad="{ Id: volcado.IdPartida }"
            formulario-padre="frmVolcarMercanciaUnidadLogisticaLectura"
            componente-aplicacion="PCUltimosVolcados"
            :mostrar-precarga="false"
            :modo-consulta-agrupada="true"
            :datos="datosPersonalizaciones"
          />
        </f7-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import PCInformacionSinRegistros from '@/components/production/traceability/PCInformacionSinRegistros.vue';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import SoportePersonalizacion from '@/js/services/soportePersonalizacion';
import SoporteCadena from '@/js/common/HiChainSupport';
import UCInformationWithoutSearchRecord from '@/components/common/UCInformationWithoutSearchRecord.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import { HiNotification } from '@/js/common/HINotificationSupport';
import PCOperacionesPersonalizadas from './PCOperacionesPersonalizadas.vue';

export default {
  name: 'PCUltimosVolcados',
  components: {
    PCInformacionSinRegistros,
    UCInformationWithoutSearchRecord,
    UCPreload,
    PCOperacionesPersonalizadas,
  },
  props: {
    activo: {
      type: Boolean,
      default: true,
    },
    numeroDeVolcadosMostrar: {
      type: Number,
      default: 10,
    },
    filtro: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['volcadoSeleccionado'],

  data() {
    return {
      puntoDeVolcado: null,
      lineaProduccion: null,
      volcados: null,
      seleccionVolcado: null, // Contiene el elemento de volcado seleccionado.
      mostrarPrecarga: false, // Muestra el componente de precargadatosPersonalizaciones: [],
      datosPersonalizaciones: [],
      personalizacionVolcadoPartidasActiva: false,
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDeVolcadoSeleccionado',
      'lineaDeProduccionSeleccionada',
    ]),
  },
  watch: {
    activo(val) {
      if (val) {
        this.ObtenerPuntoDevolcadoSeleccionado();
        this.ObtenerLineaDeProduccionSeleccionada();
        this.InicializarComponente();
      }
    },
    volcados(val) {
      if (val !== null && val.length > 0) {
        this.ObtenerPersonalizacionesPlanificaciones(val);
      }
    },
    /*
    actualizar(val) {
      if (val != null) this.ObtenerMercanciaVolcada();
    },
    */
    cantidadCajasVolcar() {
      this.RecalcularCantidadesUnidadVolcado();
    },
    cantidadKilosVolcar() {
      this.RecalcularCantidadesUnidadVolcado();
    },
    filtro(val) {
      if (val != null) {
        this.AplicarFiltrado(val);
      } else {
        this.LimpiarFiltros();
      }
    },
  },
  created() {
    this.ObtenerPuntoDevolcadoSeleccionado();
    this.ObtenerLineaDeProduccionSeleccionada();
    this.InicializarComponente();
  },
  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      this.ConfigurarPersonalizacionesFrm();
    },

    /**
     * @public
     * @returns {void}
     */
    ActualizarDatos() {
      Log(this, this.ActualizarDatos.name);
      this.ObtenerMercanciaVolcada();
    },

    ConfigurarPersonalizacionesFrm() {
      Log(this, this.ConfigurarPersonalizacionesFrm.name);
      this.personalizacionVolcadoPartidasActiva = SoportePersonalizacion.ExistePersonalizacion('frmVolcarMercanciaUnidadLogisticaLectura', 'PCUltimosVolcados');
    },

    ObtenerPuntoDevolcadoSeleccionado() {
      Log(this, this.ObtenerPuntoDevolcadoSeleccionado.name);
      this.puntoDeVolcado = this.puntoDeVolcadoSeleccionado;
    },

    ObtenerLineaDeProduccionSeleccionada() {
      Log(this, this.ObtenerLineaDeProduccionSeleccionada.name);
      this.lineaProduccion = this.lineaDeProduccionSeleccionada;
    },

    async ObtenerPersonalizacionesPlanificaciones(lstvolcados) {
      Log(this, this.ObtenerPersonalizacionesPlanificaciones.name);
      if (!this.personalizacionVolcadoPartidasActiva) {
        return;
      } // Comprueba si esta activa.
      this.datosPersonalizaciones = [];
      const entidades = [];

      const arrayLstVolcados = lstvolcados.map((i) => [i.IdPartida, i]);

      const mapVolcados = new Map(arrayLstVolcados);

      const lstPVolcadosUnicos = [...mapVolcados.values()];

      lstPVolcadosUnicos.forEach((e) => {
        entidades.push({ Id: e.IdPartida });
      });

      this.datosPersonalizaciones = await SoportePersonalizacion.ObtenerOperacionesPersonalizadasEntidadMultiple(entidades, 1, 'frmVolcarMercanciaUnidadLogisticaLectura', 'PCUltimosVolcados');
    },

    ObtenerMercanciaVolcada() {
      this.ObtenerPuntoDevolcadoSeleccionado();
      Log(this, this.ObtenerMercanciaVolcada.name);
      const self = this;
      let cantidad = this.numeroDeVolcadosMostrar;
      this.mostrarPrecarga = true;
      cantidad ??= 0;
      ConexionTA.callObtenerColaDeVolcadoPorIdPuntoVolcado(this.puntoDeVolcado.Id, cantidad).then((result) => {
        if (result.Valor) {
          self.volcados = JSON.parse(result.Mensaje);

          self.mostrarPrecarga = false;
        } else {
          self.mostrarPrecarga = false;
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch((error) => {
          self.mostrarPrecarga = false;
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(this, this.ObtenerMercanciaVolcada.name, error);
        });
    },

    FormatearCadena(cadena, longitudMaxima) {
      return SoporteCadena.TextoLogitudMaxima(cadena, longitudMaxima);
    },

    VerDetalleVolcado(idVolcado) {
      Log(this, this.VerDetalleVolcado.name);
      [this.seleccionVolcado] = this.volcados.filter((v) => v.Id === idVolcado);

      // eventBus.emit('PCUltimosVolcados_volcadoSeleccionado', this.seleccionVolcado);
      this.$emit('volcadoSeleccionado', this.seleccionVolcado);
    },

    FormatearFecha(fechaYHora) {
      return SoporteFechaYHora.obtenerHorasYMinutos(fechaYHora);
    },
    /** Método CancelarProcesoDeRecuperado */
    CancelarProcesoDeRecuperado() {
      Log(this, this.CancelarProcesoDeRecuperado.name);
      this.actionsSeleccionRecuperado = false;
      this.mostrarRecuperadoParcialEnvases = false;
      this.mostrarRecuperadoParcialKilos = false;
    },
    /** Método AplicarFiltrado */
    AplicarFiltrado(filtro) {
      Log(this, this.AplicarFiltrado.name);

      // Busqueda nombre producto.
      if (filtro[0].CampoFiltrante === 'FamiliaArticulo') {
        this.AplicarFiltradoPorNombreFamilia(filtro);
        return;
      }
      // Busqueda por partida
      if (filtro[0].CampoFiltrante === 'IdentificadorUnicoCodigoDeBarras') {
        this.AplicarFiltradoPorPartida(filtro);
        return;
      }
      // Busqueda por Unidad Logistica
      if (filtro[0].CampoFiltrante === 'NumeroSerie') {
        this.AplicarFiltradoPorUnidadLogistica(filtro);
      }
    },
    /** Método AplicarFiltradoPorNombreFamilia */
    AplicarFiltradoPorNombreFamilia(filtro) {
      Log(this, this.AplicarFiltradoPorNombreFamilia.name);
      const filtroValor = filtro[0].Filtro;
      const volcadosFiltrado = [];
      this.volcados.forEach((vol) => {
        if (vol.FamiliaArticulo.Nombre.toLowerCase().search(filtroValor.toLowerCase()) !== -1) {
          volcadosFiltrado.push(vol);
        }
      });
      this.volcados = volcadosFiltrado;
    },
    /** Método AplicarFiltradoPorPartida */
    AplicarFiltradoPorPartida(filtro) {
      Log(this, this.AplicarFiltradoPorPartida.name);
      let filtroValor = filtro[0].Filtro;
      const volcadosFiltrado = [];
      if (filtroValor.charAt(0) === '/') {
        filtroValor = filtroValor.substr(1);
      }
      this.volcados.forEach((vol) => {
        if (vol.IdentificadorPartida === filtroValor) {
          volcadosFiltrado.push(vol);
        }
      });
      this.volcados = volcadosFiltrado;
    },

    /** Método AplicarFiltradoPorUnidadLogistica */
    AplicarFiltradoPorUnidadLogistica(filtro) {
      Log(this, this.AplicarFiltradoPorUnidadLogistica.name);
      const filtroValor = filtro[0].Filtro;
      const volcadosFiltrado = [];
      this.volcados.forEach((vol) => {
        if (vol.NumeroSerie === filtroValor) {
          volcadosFiltrado.push(vol);
        }
      });
      this.volcados = volcadosFiltrado;
    },
    /** Método LimpiarFiltros */
    LimpiarFiltros() {
      Log(this, this.LimpiarFiltros.name);
      this.ObtenerMercanciaVolcada();
    },

    ObtenerCadenaNumerosPartidas(lstPartidas) {
      Log(this, this.ObtenerCadenaNumerosPartidas.name);
      let cadenaPartidas = '';
      try {
        lstPartidas.forEach((p) => {
          const seriePartida = p.Partida.Serie != null ? p.Partida.Serie : '';
          cadenaPartidas += `${seriePartida}/${p.Partida.Numero}, `;
        });
        cadenaPartidas = cadenaPartidas.slice(0, -2); // Quitamos el último carácter.
      } catch (error) {
        LogError('No se pudo obetener cadena', error);
      }
      return cadenaPartidas;
    },
  },
};
</script>

<style scoped>
.div-registrosDeMovimientos {
  margin-top: 25px;
}

.div-registroMovimiento {
  margin-left: 28px;
  padding-right: 28px;
  margin-top: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid var(--his-disabled);
}

.span-numeroPartida {
  color: var(--his-darkgray);
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
}

.col-cantidadEnvasesVolcado {
  font-size: 26px;
  font-weight: 900;
  line-height: 29px;
  color: #66ba33;
  display: flex;
  justify-content: center;
}

.col-cantidadEnvasesVolcado .span-ttl-unidades-volcadas {
  color: #66ba33;
}

.col-cantidadEnvasesVolcado .span-ttl-unidades-recuperadas {
  color: var(--his-tomate);
}

.col-productoRegistroMovimiento {
  font-size: 16px;
  font-weight: 500;
  line-height: 17px;
  color: #009ba6;
  padding-top: 7px;
}

.col-ttlVolcadoORecuperado {
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  color: var(--his-silver);
  text-align: right;
  display: flex;
  justify-content: center;
}

.div-horaRegistroMovimientoYPartida {
  display: flex;
}

.div-horaRegistroMovimiento {
  max-height: 21px;
}

.div-numeroPartida {
  margin-left: 20px;
}

.row-nombreProductoYCantidadEnvases {
  padding-bottom: 0;
}

.div-componenteInformacionSinRegistros {
  height: 64vh !important;
}
</style>
